var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJespr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 8,
    y: 8,
    fill: "#fff",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#41474a",
    d: "M23.699 22.934c0 .754-.607 1.361-1.362 1.365H13v1.312h9.326A2.68 2.68 0 0 0 25 22.938V13h-1.301z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJespr);
export default __webpack_public_path__ + "static/media/jespr.fc6012b090c74986c72058ca7328889d.svg";
export { ForwardRef as ReactComponent };